enum AccountPaymentRestriction {
  ASK = 'ASK',
  BSU = 'BSU',
  NONE = 'NONE',
  SUPERSPAR = 'SUPERSPAR',
  SPAREKONTO_PLUSS = 'SPAREKONTO_PLUSS',
}

export default AccountPaymentRestriction;
